<template lang="html">
  <div class="section" v-if="expired || expires_soon">
    <div class="flex-box vertically-centered">
      <i class="si-icon-bold si-icon-6x si-icon-text-5x si-warning_circle"></i>
      <div class="bold flex-grow-1 body-17">
        {{ message }}
      </div>
      <div class="">
        <SymbiumButton
          text="Renew Now"
          :onClick="openRenewModal"
          :isSmall="true"
        />
      </div>
    </div>
    <PurchaseModal
      :total="5000"
      :paymentReadyCallback="renewBuildPlus"
      :error="error"
      :note="expireNote"
    />
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import LoadUser from 'src/mixins/LoadUser.js'

import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import PurchaseModal from 'src/components/common/modals/PurchaseModal.vue'

export default {
  components: { SymbiumButton, PurchaseModal },
  mixins: [LoadUser],
  methods: {
    assignData(data) {
      var product = _.find(data.ownerships, o => {
        return o.product == 'Symbium Build+'
      })
      if (product) {
        this.expired = product.expired
        this.expires_soon = product.expires_soon
        this.expireDate = moment(product.expires).format('MMMM D, YYYY')
        this.nextExpireAfterRenew = product.nextExpireAfterRenew
      }
    },
    openRenewModal() {
      this.$modal.show('purchase-modal')
    },
    renewBuildPlus(data) {
      this.$renewBuildPlus(data.token.id, this.afterPayment, this.errorPayment)
    },
    afterPayment() {
      this.$emit('renew-success')
      this.$modal.hide('purchase-modal')
    },
    errorPayment() {
      this.$modal.hide('purchase-modal')
      alert('something went wrong please try it again')
    },
  },
  computed: {
    message() {
      if (this.expired) {
        return `Your Build+ subscription expired on ${this.expireDate}`
      } else if (this.expires_soon) {
        return `Your Build+ subscription will expire on ${this.expireDate}`
      }

      return ''
    },
    expireNote() {
      return `Upon renewal, your subscription will be extended by till ${this.nextExpireAfterRenew}`
    },
  },
  data() {
    return {
      expired: false,
      expires_soon: false,
      expireDate: null,
      nextExpireAfterRenew: null,
    }
  },
}
</script>

<style lang="scss"></style>
